require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./coi-policy.json") })
        }
      }, "path---coi-policy");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---coi-policy!./.cache/json/coi-policy.json
// module id = ./node_modules/gatsby-module-loader/index.js?name=path---coi-policy!./.cache/json/coi-policy.json
// module chunks = 231608221292675